import {
  Book as BookIcon,
  Briefcase,
  Calendar as CalendarIcon,
  Home as HomeIcon,
  Icon,
  MapPin,
  MessageSquare as MessageIcon,
  Settings as SettingsIcon,
  User as UserIcon,
} from "react-feather";
import {
  FranchiseType,
  PersonStatus,
  PropositionAllocation,
} from "@hubcapp/types";
import { InstructorType } from "context/AuthProvider/types";
import { Learner as LearnerIcon } from "@hubcapp/icons";
import { useFeature } from "flagged";

export type Page = {
  title: string;
  pages: Array<PageChild>;
};

export type PageChild = {
  title: string;
  icon?: Icon;
  href?: string;
  children?: Array<PageChild>;
  label?: () => JSX.Element;
};

export type Config = Array<Page>;

const config = (
  instructor?: InstructorType,
  propositions: PropositionAllocation[] = [],
): Config => {
  const isActiveInstructor =
    !instructor?.status || instructor.status === PersonStatus.Active;
  const isMyBusinessProfileEnabled = useFeature("myBusinessProfileEnabled");
  const isEligibleForBusinessProfile = propositions?.some(
    proposition =>
      proposition.proposition.type === FranchiseType.Full ||
      proposition.proposition.type === FranchiseType.Trainee,
  );
  const pages: PageChild[] = [
    {
      title: "Home",
      href: "/home", // If the href is just "/" then it won't have the 'active' style
      icon: HomeIcon,
    },
    isActiveInstructor
      ? {
          title: "Calendar",
          href: "/calendar",
          icon: CalendarIcon,
        }
      : null,
    isActiveInstructor
      ? {
          title: "Learners",
          href: "/learners",
          icon: LearnerIcon,
        }
      : null,
    {
      title: "Messages",
      href: "/messages",
      icon: MessageIcon,
    },
    isActiveInstructor &&
    isMyBusinessProfileEnabled &&
    isEligibleForBusinessProfile
      ? {
          title: "My business profile",
          href: "/my-business-profile",
          icon: Briefcase,
        }
      : null,
    isActiveInstructor
      ? {
          title: "Accounts",
          href: "/accounts",
          icon: BookIcon,
        }
      : null,
    {
      title: "My details",
      href: "/settings/my-details",
      icon: UserIcon,
    },
    isActiveInstructor
      ? {
          title: "Areas & prices",
          href: "/settings/areas-and-prices",
          icon: MapPin,
        }
      : null,
    isActiveInstructor
      ? {
          title: "Preferences",
          href: "/settings/preferences",
          icon: SettingsIcon,
        }
      : null,
  ].filter(Boolean) as PageChild[];

  return [
    {
      title: "",
      pages,
    },
  ];
};

export default config;
